import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationService } from "./notification.service";

const resizeEventRegex = /OPEN_BANKING_RESIZE_EVENT: ([0-9]+)\|([0-9]+)/;
@Injectable({
  providedIn: "root",
})
export class EventService {
  iframeHeight: string

  constructor(
    private notificationService: NotificationService,
    private router: Router,
  ) {
    notificationService.setClearDelay(3000);
    this.iframeHeight = '1000px'
  }

  handleOpenBankingEvents(event: MessageEvent): void {
    if(event.data === "SUCCESS"){
      this.handleSuccessCase();
      return;
    }
    else if(event.data === "ERROR"){
      this.handleErrorCase();
      return;
    }
    else if(event.data === "ABORTED"){
      this.handleAbortedCase();
      return;
    }
    else if(this.isWindowResizeEvent(event.data)){
      const redimensionHeight = event.data.match(resizeEventRegex)[2] as string
      this.iframeHeight =  `${redimensionHeight}px`
    }
  }

  private isWindowResizeEvent(eventData: string){
    return eventData.match(resizeEventRegex) !== null
  }

  private handleSuccessCase() {
    this.notificationService.push({
      type: "SUCCESS",
      message: "Le parcours Open Banking s'est terminé avec succès.",
    });
    this.router.navigate(["banking-case"]);
  }

  private handleErrorCase() {
    this.notificationService.push({
      type: "ERROR",
      message: "Tentatives maximales en échec atteintes. Le client est redirigé hors de l’Open Banking.",
    });
    this.router.navigate([""]);
  }

  private handleAbortedCase() {
    this.notificationService.push({
      type: "ABORTED",
      message: "Le parcours Open Banking a été abandonné.",
    });
    this.router.navigate([""]);
  }
}
